import { Link, useLocation } from 'react-router-dom';
import { ButtonNavProps } from './buttonNav.interface';

export default function ButtonNav({ icon, text, onClick, url, src, islistIcon, isListActive, count = 0, translate = true }: ButtonNavProps) {

    // Obtener la ubicación actual
    const location = useLocation();

    // Función que comprueba si la ruta está activa
    const isActive = (path: any) => location.pathname === path;

    // Maneja el clic en el enlace o el botón
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) => {
        if (onClick) onClick(); // Llama a onClick si está definido
    };

    return (
        <>
            {url ? (
                <Link to={url} className={`button_nav ${isActive(url) ? 'active' : ''}`} onClick={handleClick}>
                    
                    {icon && <div className='icon'>
                        <i className={icon}></i>
                    </div>}
                    {src && <div className='icon'>
                        <img className='imageIcon' src={src} alt={text} />
                    </div>}
                    {count > 0 && <div className='icon'>
                        <div className='countIcon'><span className='cont'>{count}</span></div>
                    </div>}

                    <span translate={translate ? 'yes' : 'no'}> {text}</span>
                </Link>
            ) : (
                <div className={`button_nav ${isListActive ? 'active' : ''}`} onClick={handleClick}>

                    {icon && <div className='icon'>
                        <i className={icon}></i>
                    </div>}
                    {src && <div className='icon'>
                        <img className='imageIcon' src={src} alt={text} />
                    </div>}
                    {count > 0 && <div className='icon'>
                        <div className='countIcon'><span className='cont'>{count}</span></div>
                    </div>}

                    <span translate={translate ? 'yes' : 'no'}>{text}</span>
                    {islistIcon && <i className={`islistIcon ${isListActive ? 'active' : undefined} fa-solid fa-chevron-down`}></i>}
                </div>
            )}
        </>
    );
}
